const CategoryRoutes = {
  getCategories: 'getCategories',
  getSubcategories: 'getSubCategories',
};

export default CategoryRoutes